import { render, staticRenderFns } from "./LeadMessage.vue?vue&type=template&id=73222e13&scoped=true&"
import script from "./LeadMessage.vue?vue&type=script&lang=js&"
export * from "./LeadMessage.vue?vue&type=script&lang=js&"
import style0 from "./LeadMessage.vue?vue&type=style&index=0&id=73222e13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73222e13",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73222e13')) {
      api.createRecord('73222e13', component.options)
    } else {
      api.reload('73222e13', component.options)
    }
    module.hot.accept("./LeadMessage.vue?vue&type=template&id=73222e13&scoped=true&", function () {
      api.rerender('73222e13', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/leads/LeadMessage.vue"
export default component.exports